import NewsTipSimpleView from './NewsTipSimpleView'

export default NewsTipSimpleView
